import {
    createOptionPickerComponent,
    IOptionPickerProperties,
    IOptionPickerTextItem,
} from '@vfde-brix/option-picker';

/**
 * LoadingSpinner BRIX component
 *
 */
export const mountOptionPicker = (targetID: string, items, changeHandler, uuid): unknown => {
    const container = document.getElementById(targetID);

    const destionationData: IOptionPickerProperties<IOptionPickerTextItem> = {
        uuid,
        optType: 'text',
        items,
        business: {
            onChange: changeHandler,
        },
    };

    const optionPicker = createOptionPickerComponent(container, destionationData);

    (optionPicker as any).clear = () => {
        const radioButtons = document.getElementById(uuid)?.querySelectorAll('input');

        if (radioButtons) {
            radioButtons.forEach(e => {
                const input = e as HTMLInputElement;
                input.checked = false;
            });
        }
    };

    return optionPicker as any;
};
